/**
 * Premium animations and scroll effects for modern sports wear store
 */

(function() {
  'use strict';

  // Intersection Observer para animaciones al hacer scroll
  function initScrollAnimations() {
    const observerOptions = {
      threshold: [0.1],
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observar todos los elementos con clase scroll-fade-in
    document.querySelectorAll('.scroll-fade-in').forEach(el => {
      observer.observe(el);
    });
  }

  // Parallax effect en hero
  function initParallaxEffect() {
    const heroHeader = document.querySelector('.hero-premium__background');
    if (!heroHeader) return;

    window.addEventListener('scroll', () => {
      const scrollPos = window.scrollY;
      heroHeader.style.transform = `translateY(${scrollPos * 0.5}px)`;
    });
  }

  // Sticky header effect
  function initStickyHeader() {
    const header = document.querySelector('.header-premium');
    if (!header) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

  // Smooth scroll behavior
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Contador de números animado
  function animateCounters() {
    const counters = document.querySelectorAll('[data-count]');
    const durations = 2000; // 2 segundos

    const observerOptions = {
      threshold: 0.7
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('counted')) {
          const finalValue = parseInt(entry.target.dataset.count);
          const startValue = 0;
          const startTime = Date.now();

          const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / durations, 1);
            const currentValue = Math.floor(startValue + (finalValue - startValue) * progress);
            entry.target.textContent = currentValue;

            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              entry.target.textContent = finalValue;
              entry.target.classList.add('counted');
            }
          };

          animate();
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    counters.forEach(counter => observer.observe(counter));
  }

  // Efecto de hover en producto cards
  function initCardHoverEffects() {
    const cards = document.querySelectorAll('.product-card-modern, .best-seller-card, .benefit-card, .testimonial-card');

    cards.forEach(card => {
      card.addEventListener('mouseenter', function() {
        this.style.transition = 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      });
    });
  }

  // Cargar más productos con AJAX (si es necesario)
  function initLoadMore() {
    const loadMoreBtn = document.querySelector('[data-load-more]');
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      this.disabled = true;
      this.textContent = 'Cargando...';

      // Simulación de carga
      setTimeout(() => {
        this.textContent = 'Cargar más';
        this.disabled = false;
      }, 1000);
    });
  }

  // Drawer/menú mobile
  function initMobileMenu() {
    const menuOpen = document.querySelector('[data-open-menu]');
    const menuClose = document.querySelector('[data-close-menu]');
    const drawer = document.querySelector('[data-mobile-drawer]');

    if (!menuOpen || !menuClose || !drawer) return;

    menuOpen.addEventListener('click', () => {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    menuClose.addEventListener('click', () => {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    });

    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // Validator de formularios
  function initFormValidation() {
    const forms = document.querySelectorAll('form[data-validate]');

    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const inputs = this.querySelectorAll('input[required], textarea[required]');
        let isValid = true;

        inputs.forEach(input => {
          if (!input.value.trim()) {
            isValid = false;
            input.classList.add('error');
          } else {
            input.classList.remove('error');
          }
        });

        if (!isValid) {
          e.preventDefault();
        }
      });
    });
  }

  // Performance: Lazy loading de imágenes
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const images = document.querySelectorAll('img[loading="lazy"]');

      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src || img.src;
            img.classList.add('loaded');
            imageObserver.unobserve(img);
          }
        });
      });

      images.forEach(img => imageObserver.observe(img));
    }
  }

  // Compartir en redes sociales
  function initSocialShare() {
    const shareButtons = document.querySelectorAll('[data-share]');

    shareButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const platform = this.dataset.share;
        const url = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(document.title);

        let shareUrl = '';

        switch(platform) {
          case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            break;
          case 'twitter':
            shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
            break;
          case 'instagram':
            // Instagram no permite compartir directamente, solo mostrar aviso
            alert('Abre Instagram manualmente y comparte la URL');
            return;
          case 'whatsapp':
            shareUrl = `https://wa.me/?text=${title} ${url}`;
            break;
        }

        if (shareUrl) {
          window.open(shareUrl, '_blank', 'width=600,height=400');
        }
      });
    });
  }

  // Carrito flotante
  function initFloatingCart() {
    const cartIcon = document.querySelector('[data-cart-icon]');
    const cartCount = document.querySelector('[data-cart-count]');

    if (!cartIcon) return;

    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      // Implementación específica según el tema
      console.log('Cart clicked');
    });
  }

  // Animación de notificación toast
  function showNotification(message, type = 'info') {
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.innerHTML = `
      <div class="toast__content">
        ${message}
      </div>
      <button class="toast__close" aria-label="Close">✕</button>
    `;

    document.body.appendChild(toast);

    // Trigger animation
    setTimeout(() => toast.classList.add('visible'), 10);

    const closeBtn = toast.querySelector('.toast__close');
    closeBtn.addEventListener('click', () => {
      toast.classList.remove('visible');
      setTimeout(() => toast.remove(), 300);
    });

    // Auto remove after 4 seconds
    setTimeout(() => {
      if (document.contains(toast)) {
        toast.classList.remove('visible');
        setTimeout(() => toast.remove(), 300);
      }
    }, 4000);
  }

  // Inicializar todo al cargar el DOM
  document.addEventListener('DOMContentLoaded', function() {
    initScrollAnimations();
    initParallaxEffect();
    initStickyHeader();
    initSmoothScroll();
    animateCounters();
    initCardHoverEffects();
    initLoadMore();
    initMobileMenu();
    initFormValidation();
    initLazyLoading();
    initSocialShare();
    initFloatingCart();
  });

  // Exponer función para mostrar notificaciones globalmente
  window.shopNotify = showNotification;
})();
